import type { MatchedSiteMaterialV2 } from 'api';

export const getPreferredPortOfLoadingIdFromMatch = (siteMaterial: MatchedSiteMaterialV2): number | undefined => {
  return (
    siteMaterial.latest_offer?.port_of_loading_id ||
    siteMaterial.latest_supply_signal?.port_of_loading_id ||
    siteMaterial.site.trade_company.preferred_port_of_loading_id ||
    siteMaterial.historical_port_of_loading_id ||
    undefined
  );
};
